import { render } from "./TTNPrint.vue?vue&type=template&id=6056a798&scoped=true&ts=true"
import script from "./TTNPrint.vue?vue&type=script&lang=ts"
export * from "./TTNPrint.vue?vue&type=script&lang=ts"

import "./TTNPrint.vue?vue&type=style&index=0&id=6056a798&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6056a798"]])

export default __exports__